import authRules from '../authRules.js';

const approveTours = (user) => {
  const { approveTours } = user.securityLevels;
  if (approveTours >= authRules.approveTours.approveTours) {
      return true;
  } else {
      return false;
    }
  }

export default approveTours;